import { Grid } from '@mui/material'

import PhoneEditForm from './PhoneEditForm'

export default function PhoneList({ path, fields, control, append, minCount, ...props }) {
  const phoneList = [...fields]
  while (phoneList.length < minCount) {
    phoneList.push({ type: '', number: '' })
  }
  return (
    <Grid container spacing={2}>
      {phoneList.map((item, index) => (
        <PhoneEditForm
          key={item.id}
          path={path}
          fields={fields}
          control={control}
          append={append}
          item={item}
          index={index}
          {...props}
        />
      ))}
    </Grid>
  )
}
